import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import TicketAssign from "./ticket-assign-item";

const AssignTickets = (props) => {
  const {
    // parent
    formHasError,

    // own
    manageTicketsCount,
  } = props;
  // console.log("manageTicketsCount :- ", manageTicketsCount);

  const renderTicketAssign = () => {
    let returnHtml = [];

    let groupTicketsArr = _.filter(manageTicketsCount, (o) => {
      return o?.noofchildtickets;
    });
    let generalTicketsArr = _.filter(manageTicketsCount, (o) => {
      return o?.type !== "addon";
    });
    let totalGeneralTickets = _.sumBy(generalTicketsArr, function (o) {
      return o?.quantity;
    });
    let addonTicketsArr = _.filter(manageTicketsCount, (o) => {
      return o?.type === "addon";
    });
    let totalAddonTickets = _.sumBy(addonTicketsArr, function (o) {
      return o?.quantity;
    });

    let availableForSelfAssign = false;
    let ticketarray = manageTicketsCount;
    if (
      groupTicketsArr?.length === 0 &&
      totalGeneralTickets === 1 &&
      totalAddonTickets > 0
    ) {
      availableForSelfAssign = true;
      let genralticket = _.filter(manageTicketsCount, (item) => {
        return item.type !== "addon";
      });
      let addontickets = _.filter(manageTicketsCount, (item) => {
        return item.type === "addon";
      });
      ticketarray = [...genralticket, ...addontickets]; // sorting the tickets list according to the general ticket always comes first
    }

    _.forEach(ticketarray, (item) => {
      let tid = item?.ticketid;
      let qty = item?.noofchildtickets
        ? item?.noofchildtickets
        : item?.quantity;

      for (let i = 0; i < qty; i++) {
        item.index = i;
        item.position = 1 + i;
        let finalitem = JSON.parse(JSON.stringify(item));

        returnHtml.push(
          <TicketAssign
            key={`tickets_key_${tid}_${i}`}
            form={`TicketAssignForm_${tid}_${i}`}
            assign={finalitem}
            formHasError={formHasError}
            availableForSelfAssign={availableForSelfAssign}
            groupTicketsArr={groupTicketsArr}
            generalTicketsArr={generalTicketsArr}
            totalGeneralTickets={totalGeneralTickets}
            addonTicketsArr={addonTicketsArr}
            totalAddonTickets={totalAddonTickets}
          />
        );
      }
    });

    return returnHtml;
  };

  return (
    <>
      {manageTicketsCount?.length > 0 ? (
        <ul className="space-y-3">{renderTicketAssign()}</ul>
      ) : (
        ""
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    manageTicketsCount: state.manageTicketsCount,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignTickets);
